import { useFullStoryPageView } from 'hooks/useFullstoryPageView';
import { settingsConfig } from 'components/Settings/settingsConfig';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import SettingHeader from 'components/Settings/Components/SettingHeader/settingHeader';
import { MainContent } from 'components/common/PageContainer/MainContent';
import { NarrativeTemplates } from 'components/Settings/Components/NarrativeTemplates/components/NarrativeTemplates/narrativeTemplates';

export const NarrativeTemplatesPage = () => {
    useFullStoryPageView({ pageName: settingsConfig.narrativeTemplates.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <SettingHeader
                    title={settingsConfig.narrativeTemplates.title}
                    subTitle={'Edit narrative templates per component'}
                />
            </HeaderWrapper>
            <MainContent>
                <NarrativeTemplates />
            </MainContent>
        </PageContainer>
    );
};
